module.exports = ".blue_text {\n\tcolor: #1427e6;\n\tmargin: 0px;\n\topacity: 1;\n}\n\nh2.blue_text {\n\tfont-size: 21px;\n\tfont-weight: 900;\n}\n\n.pref_table {\n\twidth: 100%;\n\tpadding: 10px 0;\n}\n\n.btn-action {\n    margin-top: 24px;\n}\n\nthead {\n\tfont-weight: 900;\n}\n\ntr>td:nth-child(2), tr>td:nth-child(3) {\n\ttext-align: center;\n}\n\n.edit-contact {\n\ttext-align: center;\n\tmargin-top: 32px;\n}\n\n.edit-contact a {\n\ttext-decoration: underline;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/notification-preference/notification-preference.component.css
// module id = ./src/app/profile/notification-preference/notification-preference.component.css
// module chunks = main